import { DateTime } from 'luxon';

export const calculateRentalDays = (startDate: Date, endDate: Date): number => {
  const startDateTime = DateTime.fromJSDate(startDate).startOf('minute').setZone('Europe/Berlin');
  const endDateTime = DateTime.fromJSDate(endDate).startOf('minute').setZone('Europe/Berlin');
  const offsetStart = startDateTime.offset * 60;
  const offsetEnd = endDateTime.offset * 60;
  const diff = endDateTime.toSeconds() + offsetEnd - (startDateTime.toSeconds() + offsetStart);
  return Math.ceil(Math.round(diff) / 86400);
};
